export type SurveyTriggerSite = 'live' | 'home' | 'deposit_success' | 'bet_settled';

export type SurveyRequest =
  | { kind: 'trigger'; site: SurveyTriggerSite; at: number }
  | { kind: 'open'; surveyId: number; triggerCode: 'cabinet_banner' | null; campaignId: number | null; at: number };

type SurveyRequestListener = (request: SurveyRequest) => void;

export const BUFFER_TTL_MS = 5000;
let listener: SurveyRequestListener | null = null;
let buffer: SurveyRequest[] = [];

const deliver = (request: SurveyRequest): void => {
  if (listener) {
    listener(request);
    return;
  }
  buffer = [ ...buffer.filter((item) => request.at - item.at < BUFFER_TTL_MS), request ].slice(-5);
};

export const requestSurveyTrigger = (site: SurveyTriggerSite): void => {
  deliver({ kind: 'trigger', site, at: Date.now() });
};

export const openSurvey = (surveyId: number, triggerCode: 'cabinet_banner' | null = null, campaignId: number | null = null): void => {
  deliver({ kind: 'open', surveyId, triggerCode, campaignId, at: Date.now() });
};

export const subscribeSurveyRequests = (fn: SurveyRequestListener): (() => void) => {
  listener = fn;
  const now = Date.now();
  const pending = buffer.filter((item) => now - item.at < BUFFER_TTL_MS);
  buffer = [];
  pending.forEach(fn);
  return () => {
    if (listener === fn) {
      listener = null;
    }
  };
};
